import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 0.856049L21 6.41161V9.00001H1V6.41161L11 0.856049ZM6 11V19H4V11H6ZM12 11V19H10V11H12ZM18 11V17H16V11H18ZM22.5961 17.9394L16.9392 23.5963L13.4037 20.0608L14.8179 18.6466L16.9392 20.7679L21.1819 16.5252L22.5961 17.9394ZM1 21H12V23H1V21Z"}}]};

const InstitutionCheckedFilled = Vue.extend<IconProps>({
  name: 'InstitutionCheckedFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'institution-checked-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default InstitutionCheckedFilled;
